import {ModuleTypeInstance, Keys} from './ModuleTypeInstance';
export class ImportFileService {
  public static GetInstance(Id: number) {
    return ModuleTypeInstance.GetInstanceOfCurrentModule(Id as Keys);
  }
}
